import '../transactionAmountThreshold/transactionAmountThreshold.scss'
import { useEffect, useState } from 'react'
import { Autocomplete, Box, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { mapCodesToNames } from '../../../../utilities/MapCodesToNames'
import { toCamelCase } from '../../../../utilities/formatters/camelCase'

const MinimumTransactionAmount = ({
  propertie,
  ruleParameters,
  setRuleParameters,
  isEditing,
  possibleValues,
  schema,
}) => {
  const [currency, setCurrency] = useState(null)
  const [amount, setAmount] = useState('')
  const { t } = useTranslation(['common', 'rules'])

  useEffect(() => {
    if (ruleParameters[propertie]) {
      const param = ruleParameters[propertie]
      setCurrency(param.currency || null)
      setAmount(param.amount !== undefined ? param.amount : '')
    }
  }, [propertie, ruleParameters])

  useEffect(() => {
    let updatedParams = { ...ruleParameters }

    if (!currency || amount === '' || amount === null) {
      delete updatedParams[propertie]
    } else {
      updatedParams[propertie] = {
        currency: currency,
        amount: amount,
      }
    }

    setRuleParameters(updatedParams)
  }, [currency, amount])

  return (
    <Box className="threshold-container">
      {schema?.description && <Typography variant="subtitle4">{t(`rules:${toCamelCase(schema.description)}`)}</Typography>}

      <Box className="threshold-inputs">
        <Typography variant="title3">{t('common:currency')}</Typography>
        <Autocomplete
          options={possibleValues}
          getOptionLabel={(option) => mapCodesToNames(option)}
          filterSelectedOptions
          value={currency}
          onChange={(e, value) => setCurrency(value)}
          disabled={!isEditing}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder={`${t('common:select')} ${t('common:or')} ${t('common:search')}...`}
            />
          )}
        />
      </Box>

      <Box className="threshold-inputs">
        <Typography variant="title3">{t('common:amount')}</Typography>
        <TextField
          fullWidth
          disabled={!isEditing}
          variant="outlined"
          size="small"
          type="number"
          placeholder={t('common:amount')}
          value={amount}
          onChange={(e) => {
            const val = e.target.value
            setAmount(val !== '' ? parseInt(val, 10) : '')
          }}
        />
      </Box>
    </Box>
  )
}

export default MinimumTransactionAmount
